import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const FloatingMenuText = styled.span<React.CSSProperties>`
  font-family: ${Fonts['regular']};
  font-size: ${32 * Screen.widthRatio}px;
`;

export default FloatingMenuText;
